import { useEffect } from 'react'
import { useLocation } from 'react-router-dom-v7'
import { gtm } from '@/common/services/gtm/gtm.service'

export function useGtmMembershipTier() {
    const location = useLocation()
    useEffect(() => void gtm.customEvents.userPropertiesUpdate(), [location.pathname])
}
